module.exports = __webpack_public_path__ + "img/django.d7428c07.svg";